export class EnvironmentService {
  static isStagingOrDev() {
    return (window.location.host.includes('staging') ||
      window.location.host.includes('localhost'));

  }

  static isDev() {
    return window.location.host.includes('localhost');
  }
}
